<template>
	<transition>
		<div v-if="$store.state.productSelectorOpen" class="products">
			<div class="products__categories">
				<span class="products__category active">ICU category</span>
			</div>
			<div class="products__list-wrapper">
				<div class="products__list">
					<div class="products__list-items">
						<div
							v-for="product in products"
							:key="product.name"
							class="products__item"
							:class="{ 'products__item--active': product.name === $store.state.activeProduct }"
							@click="onProductClick(product)"
						>
							<div
								class="products__item-img"
								:style="{ backgroundImage: getProductImagePath(product) }"
							/>
							<span class="products__item-title">{{ product.title }}</span>
						</div>
					</div>
				</div>
				<!-- <div class="products__list-mask-left"></div>
				<div class="products__list-mask-right"></div> -->
			</div>
		</div>
	</transition>
</template>

<script>
import productsDefinition from '../config/products'

export default {
	data() {
		return {
			activeCategory: 'ICU'
		}
	},
	computed: {
		products() {
			return productsDefinition.filter(it => it.category === this.activeCategory)
		}
	},
	methods: {
		getProductImagePath(product) {
			return 'url(' + require(`@/assets/images/products/${product.name}/${product.image}`) + ')'
		},
		onProductClick(product) {
      localStorage.setItem('linetSelectedProduct', product.name)
			// window.location.reload()
			window.location.href = `/${product.name}`
		}
	}
}
</script>

<style lang="scss" scoped>
.products {
	position: absolute;
	top: 30px;
	width: 100%;
	height: calc(100vh - 30px);
	background-color: rgba(255, 255, 255, 0.5);
	backdrop-filter: blur(10px);
	transition: all 200ms ease;
	display: flex;
	flex-direction: column;
	z-index: 200;

	> div {
		transition: opacity 300ms ease 200ms;
	}

	&.v-enter-from, &.v-leave-to {
		background-color: transparent;
		backdrop-filter: none;

		> div {
			opacity: 0;
		}
	}
	&.v-leave-to {
		> div {
			transition: opacity 300ms ease;
		}
	}

	&__categories {
		padding: 30px 60px;
	}

	&__category {
		color: $clrGrey200;
		font-size: 34px;

		&.active {
			color: $clrRed;
		}
	}

	&__list {
		width: calc(100vw);
		padding: 20px 10vw 60px;
		overflow-x: auto;
		overflow-y: hidden;
		scrollbar-color: #777 $clrRed;
		mask-image: linear-gradient(90deg, transparent 0%, #333 8%, black 10%, black 90%, #333 92%, transparent 100%);

		&::-webkit-scrollbar {
			height: 10px;
		}
		&::-webkit-scrollbar-track {
			background-color: transparent;
			background: linear-gradient(0deg, rgba(255,255,255,0) 0%, rgba(255,255,255,0) 30%, $clrRed 30%, $clrRed 70%, rgba(255,255,255,0) 70%, rgba(255,255,255,0) 100%);
			margin: 0 10vw;
		}
		&::-webkit-scrollbar-thumb {
			background-color: $clrRed;
			border-radius: 20px;
		}

		&-wrapper {
			flex: 1;
			display: flex;
			flex-direction: column;
			justify-content: center;
			margin-bottom: 30px;
			position: relative;
		}

		&-items {
			display: inline-flex;
			justify-content: center;
			min-width: 100%;
		}

		// &-mask-left {
		// 	position: absolute;
		// 	top: 0;
		// 	left: 0;
		// 	height: 100%;
		// 	width: 10vw;
		// 	background: linear-gradient(90deg, rgba(255,255,255,1) 0%, rgba(255,255,255,0) 100%);
		// }
	}

	&__item {
		margin: 0 20px;
		width: calc(26.67vw - 40px);
		position: relative;
		cursor: pointer;

    &:first-child {
      .products__item-img {
        transform: scale(1.1);
      }

      &:hover {
        .products__item-img {
          transform: scale(1.25);
        }
      }
      
    }

    &--active {
      &:first-child {
        .products__item-img {
          transform: scale(1.25);
        }
      }
    }

		&-img {
			padding-top: 75%;
			background-size: contain;
			background-position: center;
			background-repeat: no-repeat;
			transform: scale(1.3);
			transition: transform 300ms ease;
		}
		&:hover &-img,
		&--active &-img {
			transform: scale(1.5);
		}

		&-title {
			width: 100%;
			font-size: 24px;
			text-transform: uppercase;
			text-align: center;
			display: inline-block;
			user-select: none;
			opacity: 0.5;
			transition: all 300ms ease;
		}
		&:hover &-title,
		&--active &-title {
			opacity: 1;
			transform: translateY(50%);
		}
	}

}
</style>
